import { gql } from '@apollo/client';

export const SelectedFileQuery = gql`
  {
    selectedFile @client
  }
`;

export const BrandEditorStateQuery = gql`
  {
    nextCover @client
    nextExistingCover @client
  }
`;

export const getBrandState = gql`
  {
    brandState @client
  }
`;

export const getOriginalBrandState = gql`
  {
    originalBrandState @client
  }
`;

export const getToastQueue = gql`
  {
    toastQueue @client
  }
`;
export const getIsCoverSaving = gql`
  {
    isCoverSaving @client
  }
`;
export const getIsLogoSaving = gql`
  {
    isLogoSaving @client
  }
`;
